"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var Errors_1 = require("./Errors");
var PointSnapshotCache = /** @class */ (function () {
    function PointSnapshotCache(point, chariot) {
        this.point = point;
        this.chariot = chariot;
        this.resolutionCache = new Map();
        this.rawCache = new Map();
        this.resolution = {
            '5M': 300000,
            '10M': 600000,
            '15M': 900000,
            '30M': 1800000,
            '1H': 3600000,
            '12H': 43200000,
            '1D': 86400000,
            '7D': 604800000,
            '30D': 2592000000
        };
    }
    PointSnapshotCache.prototype.resolutionToMs = function (resolution) {
        if (resolution in this.resolution) {
            return this.resolution[resolution];
        }
        throw new Errors_1.InvalidMethodError("Invalid resolution requested: ".concat(resolution));
    };
    PointSnapshotCache.prototype.getCountFromDatesAndResolution = function (from, to, resolution) {
        var sizeMs = this.resolutionToMs(resolution);
        from = new Date(Math.round(+from / sizeMs) * sizeMs);
        to = new Date(Math.round(+to / sizeMs) * sizeMs);
        return Math.max(Math.round((+to - +from) / sizeMs), 1);
    };
    PointSnapshotCache.prototype.getResolutionSnapshotCache = function (resolution) {
        if (this.resolutionCache.has(resolution))
            return this.resolutionCache.get(resolution);
        var map = new Map();
        this.resolutionCache.set(resolution, map);
        return map;
    };
    PointSnapshotCache.prototype.findInCache = function (cache, from, to, resolution) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKeys, encompassingKey, encompassingData, fromCollidingKey, toCollidingKey, newKey_1, data_1, data_2, prependData, newData, data_3, appendData, newData, data, newKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cacheKeys = Array.from(cache.keys());
                        encompassingKey = cacheKeys.filter(function (key) { return +key.from <= +from && +key.to >= +to; })[0];
                        if (encompassingKey) {
                            encompassingData = cache.get(encompassingKey);
                            if (encompassingData) {
                                return [2 /*return*/, encompassingData.filter(function (_a) {
                                        var snapshot = _a.snapshot;
                                        var nSnapshot = +new Date(snapshot);
                                        return nSnapshot >= +from && nSnapshot <= +to;
                                    })];
                            }
                        }
                        fromCollidingKey = cacheKeys.filter(function (key) { return +key.to >= +from && +key.from <= +from; })[0];
                        toCollidingKey = cacheKeys.filter(function (key) { return +key.to >= +to && +key.from <= +to; })[0];
                        if (!(fromCollidingKey && toCollidingKey && fromCollidingKey !== toCollidingKey)) return [3 /*break*/, 2];
                        newKey_1 = {
                            from: fromCollidingKey.from,
                            to: toCollidingKey.to
                        };
                        return [4 /*yield*/, this.get(fromCollidingKey.to, toCollidingKey.from, resolution)];
                    case 1:
                        data_1 = _a.sent();
                        cache.delete(fromCollidingKey);
                        cache.delete(toCollidingKey);
                        cache.set(newKey_1, data_1);
                        return [2 /*return*/, this.findInCache(cache, from, to, resolution)];
                    case 2:
                        if (!fromCollidingKey) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.get(fromCollidingKey.to, to, resolution)];
                    case 3:
                        data_2 = _a.sent();
                        prependData = cache.get(fromCollidingKey);
                        cache.delete(fromCollidingKey);
                        fromCollidingKey.to = to;
                        newData = data_2;
                        if (prependData)
                            newData = __spreadArray(__spreadArray([], prependData, true), data_2, true);
                        cache.set(fromCollidingKey, newData);
                        return [2 /*return*/, this.findInCache(cache, from, to, resolution)];
                    case 4:
                        if (!toCollidingKey) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.get(from, toCollidingKey.from, resolution)];
                    case 5:
                        data_3 = _a.sent();
                        appendData = cache.get(toCollidingKey);
                        cache.delete(toCollidingKey);
                        toCollidingKey.from = from;
                        newData = data_3;
                        if (appendData)
                            newData = __spreadArray(__spreadArray([], data_3, true), appendData, true);
                        cache.set(toCollidingKey, newData);
                        return [2 /*return*/, this.findInCache(cache, from, to, resolution)];
                    case 6: return [4 /*yield*/, this.get(from, to, resolution)];
                    case 7:
                        data = _a.sent();
                        newKey = { from: from, to: to };
                        cache.set(newKey, data);
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PointSnapshotCache.prototype.retrieve = function (from, to, resolution) {
        return __awaiter(this, void 0, void 0, function () {
            var sizeMs, cache_1, cache;
            return __generator(this, function (_a) {
                if (resolution) {
                    sizeMs = this.resolutionToMs(resolution);
                    from = new Date(Math.round(+from / sizeMs) * sizeMs);
                    to = new Date(Math.round(+to / sizeMs) * sizeMs);
                    cache_1 = this.getResolutionSnapshotCache(resolution);
                    return [2 /*return*/, this.findInCache(cache_1, from, to, resolution)];
                }
                cache = this.rawCache;
                return [2 /*return*/, this.findInCache(cache, from, to)];
            });
        });
    };
    PointSnapshotCache.prototype.get = function (from, to, resolution) {
        return __awaiter(this, void 0, void 0, function () {
            var count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        count = undefined;
                        if (resolution)
                            count = this.getCountFromDatesAndResolution(from, to, resolution);
                        return [4 /*yield*/, this.chariot.RestApi.unfurlGenericUnhelpfulPagination({
                                path: "/reports/snapshots",
                                params: {
                                    from_date: from.toISOString(),
                                    to_date: to.toISOString(),
                                    page_size: 5000,
                                    point_id: this.point._.id,
                                    count: count
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PointSnapshotCache;
}());
exports.default = PointSnapshotCache;
